import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { ColorPalette } from 'shared/consts/colorPalette';
import { ListItems } from 'shared/ui/ListItems';

export const ExpiredPasswordRequirements: FunctionComponent = () => {
	const { t } = useTranslation();
	return (
		<>
			<Typography variant={'body1'} color={ColorPalette.astronaut}>
				{t('password_expired.requirements.title')}
			</Typography>
			<ListItems
				sx={{
					padding: '16px 0 36px',
				}}
				list={[
					{ label: t('password_expired.requirements.req_1') },
					{ label: t('password_expired.requirements.req_2') },
					{ label: t('password_expired.requirements.req_3') },
					{ label: t('password_expired.requirements.req_4') },
					{ label: t('password_expired.requirements.req_5') },
					{ label: t('password_expired.requirements.req_6') },
					{ label: t('password_expired.requirements.req_7') },
					{ label: t('password_expired.requirements.req_8') },
					{ label: t('password_expired.requirements.req_9') },
					{ label: t('password_expired.requirements.req_10') },
				]}
			/>
		</>
	);
};
